export default function clientConfig() {
  const config = {
    codCliente: 2157, // HMG 9157 // PRD 2157
    plano: 1,
    tipo: 2, // Patrocinado
  }

  return config
}
